import { render, staticRenderFns } from "./ModalAdicionarRecursos.vue?vue&type=template&id=8674c254"
import script from "./ModalAdicionarRecursos.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarRecursos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports